<template>
    <div class="vrm-form__fieldset-item">
        <label class="sg-textfield-label" :class="{ 'sg-required': required }">
            <span class="sg-textfield-label-caption">{{ title }}</span>
            <slot name="label"></slot>
        </label>

        <div class="time-counter">
            <div
                class="time-counter__button"
                @pointerdown="startFastSet(-1)"
                @pointerup="stopFastSet"
            >
                <div class="time-counter__button__minus"></div>
            </div>
            <div class="time-counter__value">
                {{ `${model}${unit ? ' ' + unit : ''}` }}
            </div>
            <div
                class="time-counter__button"
                @pointerdown="startFastSet(1)"
                @pointerup="stopFastSet"
            >
                <div class="time-counter__button__plus"></div>
            </div>
        </div>
        <div v-show="touched" class="vrm-form_input-errors">
            <span v-if="errors.includes('required')" class="sg-input-error">
                {{ $t('form.required') }}
            </span>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class VrmTimeCounter extends Vue {
    @Prop({ type: String, default: false })
    title;
    @Prop({ type: Boolean, default: false })
    required;
    @Prop({ type: Boolean, default: false })
    disabled;
    @Prop({ type: Number, required: true })
    minimum;
    @Prop({ type: String, required: true })
    unit;
    @Prop({ type: Number, required: false })
    default;

    @Model('input')
    model;

    mounted() {
        if (!this.value) {
            if (this.default) {
                this.value = this.default;
            } else {
                this.value = this.minimum;
            }
        }
    }

    get value() {
        return this.model;
    }

    set value(newValue) {
        this.$emit('input', newValue);
    }

    timer = null;
    interval = null;
    startFastSet(addend) {
        if (this.disabled) {
            this.stopFastSet();
            return;
        }
        this.value = Math.max(this.minimum, this.value + addend);
        this.timer = setTimeout(
            function() {
                this.interval = setInterval(
                    function() {
                        this.value = Math.max(this.minimum, this.value + addend);
                    }.bind(this),
                    100,
                );
            }.bind(this),
            300,
        );
    }

    stopFastSet() {
        clearTimeout(this.timer);
        clearInterval(this.interval);
    }

    touched = false;
    errors = [];
}
</script>
